import styled, { keyframes } from "styled-components";

const pulse = keyframes`
 to {
    transform: scale(0.8);
    opacity: 0.5;
  }`;
export const LoaderContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100px;
  height: 100px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeOut 1s 1s;
  animation-fill-mode: forwards;
`;

export const Span = styled.span`
  color: #fff;
  font-size: 10vh;
  font-family: Consolas, Menlo, Monaco, monospace;
  font-weight: bold;
  display: inline-block;

  animation: ${pulse} 0.4s alternate infinite ease-in-out;
  &:nth-child(odd) {
    animation-delay: 0.4s;
  }
`;
